import { camelCase } from 'lodash';

export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
export const camelCaseToTitleCase = (str) => {
    const result = str.replace(/([A-Z])/g, ' $1');
    return capitalizeFirstLetter(result);
};

export const titleCase = (str) => capitalizeFirstLetter(camelCase(str));

export const toHumanReadable = (value: string) => {
    return value
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());
};
